import * as API from './api'
import { localFetch } from './local_fetch'

declare var Routes: any

export class TaxInformation {
  public static async calculateSalesTax(
    { address, amount }: { address: API.IAddress, amount: number },
  ): Promise<TaxInformation> {
    const payload = this.buildRequestPayload({ address, amount })

    if (!payload) {
      return TaxInformation.no_tax
    }

    const response = await localFetch(Routes.igniter_sales_tax_calculations_path(), {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
      },
    })
    const json: API.ITaxInformation = await response.json()

    return new TaxInformation(json)
  }

  public static get no_tax(): TaxInformation {
    return new TaxInformation({
      sales_tax_amount: 0.00,
      sales_tax_label: 'Sales Tax',
      errors: [],
    })
  }

  public static get placeholder(): TaxInformation {
    return new TaxInformation(
      {
        sales_tax_amount: 0.00,
        sales_tax_label: 'Sales Tax',
        errors: [],
      },
      false,
    )
  }

  private static buildRequestPayload(
    { address, amount }: { address: API.IAddress, amount: number },
  ): API.ITaxAPIRequest | null {
    const {
      address1,
      address2,
      city,
      state,
      province,
      zip,
      country,
    } = address

    const apiState = state || province

    if (!apiState || !zip) {
      return null
    }

    return {
      amount,
      address: {
        street: [ address1, address2 ].join(' '),
        city,
        state: apiState,
        zip,
        country,
      },
    }
  }

  public salesTaxAmount: number | null
  public salesTaxLabel: string
  public errors: string[]
  public isLoaded: boolean

  public constructor(api: API.ITaxInformation, isLoaded: boolean = true) {
    this.salesTaxAmount = api.sales_tax_amount
    this.salesTaxLabel = api.sales_tax_label
    this.errors = api.errors
    this.isLoaded = isLoaded
  }
}
